<div style="flex: 1;">
  <h2 class="text-uppercase">Poslední navštívené akce</h2>
  <div [loading]="akceLoading">
      <div *ngFor="let akce of akceList" class="mb-10">
          <a uiSref="doss.akce.data.overview" class="not-underline" [uiParams]="{ akceKey: akce.schema }">{{ akce.nazevAkce }}</a>
      </div>
  </div>
  <p *ngIf="!akceLoading && (!akceList || !akceList.length)" class="empty-info">Nemáte žádné navštívené akce</p>
</div>
